export default __webpack_public_path__ + "static/media/person.09aae884.png";